<ps-ui-modal class="missing-markers-modal" *ngIf="hasMissingMarkers">
  <h6 psUiModalTitle class="modal-title mr-5 text-wrap">
    <strong *ngIf="isSurveyCreated"
      >Following quotas from Decipher were not mapped and hence will not show up
      in quotas on marketplace. These Quota will also not sync with
      decipher</strong
    >
    <strong *ngIf="!isSurveyCreated"
      >Following quotas from Decipher have not been mapped and hence will not
      create quotas on marketplace to sync</strong
    >
  </h6>
  <ps-ui-modal-body>
    <div class="row" *ngFor="let localeObj of missingMarkers">
      <ul class="list-group mb-5">
        <h5 class="text-center font-weight-bold">{{ localeObj.locale }}</h5>
        <li
          class="list-group-item mx-3 text-break"
          *ngFor="let marker of localeObj.missingMarkers"
        >
          {{ marker }}
        </li>
      </ul>
    </div>
  </ps-ui-modal-body>
  <ps-ui-modal-footer>
    <div class="d-flex justify-content-end">
      <p class="mb-0 p-2" *ngIf="!isSurveyCreated">
        Click “OK” to proceed or “CANCEL” to continue mapping.
      </p>
      <div class="buttons">
        <button
          psUiButton
          color="primary"
          type="button"
          class="m-1"
          (click)="close(false)"
          *ngIf="!isSurveyCreated"
        >
          Cancel
        </button>
        <button
          psUiButton
          color="primary"
          class="m-1"
          type="button"
          (click)="close(true)"
        >
          Ok
        </button>
      </div>
    </div>
  </ps-ui-modal-footer>
</ps-ui-modal>
